import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
var container = document.getElementById('app');
var root = createRoot(container);
root.render(React.createElement(App, null));
